import { cloneDeep } from "lodash";
import { appsConfigurationOptions } from "../../consts";

const PUSH_APPS = "app/apps/PUSH_APPS";
const RESET_APPS = "app/apps/RESET_APPS";
const SET_LOADING = "app/apps/SET_LOADING";
const SET_REFRESH = "app/apps/SET_REFRESH";
const SET_ERROR = "app/apps/SET_ERROR";
const SET_APPS_MARKETS = "app/apps/SET_APPS_MARKETS";
const SET_SELECTED_APP = "app/apps/SET_SELECTED_APP";
const SET_ROLES_TO_SELECTED_APP = "app/apps/SET_ROLES_TO_SELECTED_APP";
const SET_SELECTED_APP_MARKETS_TO_ADD = "app/apps/SET_APP_MARKETS_TO_ADD";
const SET_SELECTED_APP_MARKETS_TO_DELETE = "app/apps/SET_APP_MARKETS_TO_DELETE";
const RESET_SELECTED_APP_MARKETS_TO_ADD = "app/apps/RESET_SELECTED_APP_MARKETS_TO_ADD";
const RESET_SELECTED_APP_MARKETS_TO_DELETE = "app/apps/RESET_SELECTED_APP_MARKETS_TO_DELETE";
const RESET_SELECTED_APP = "app/apps/RESET_SELECTED_APP";
const SET_MANAGE_TYPE = "app/apps/SET_MANAGE_TYPE";
const SET_ACTIVE_PAGE = "app/apps/SET_ACTIVE_PAGE";
const SET_LAST_ACTIVE_INDEX = "app/apps/SET_LAST_ACTIVE_INDEX";
const SET_IS_GENERAL_INFO_SAVED = "app/apps/SET_IS_GENERAL_INFO_SAVED";
const SET_APP_GROUP_ERROR = "app/apps/SET_APP_GROUP_ERROR";
const SET_AVAILABLE_DASHBOARDS = "app/apps/SET_AVAILABLE_DASHBOARDS";
const SET_ORIGINAL_AVAILABLE_DASHBOARDS = "app/apps/SET_ORIGINAL_AVAILABLE_DASHBOARDS";
const SET_ORIGINAL_EMAIL_MESSAGE = "app/apps/SET_ORIGINAL_EMAIL_MESSAGE";
const SET_IS_EMAIL_MESSAGE_EDITING = "app/apps/SET_IS_EMAIL_MESSAGE_EDITING";
const SET_APP_LOCALIZATIONS = "app/apps/SET_APP_LOCALIZATIONS";
const DELETE_APP_LOCALIZATION = "app/apps/DELETE_APP_LOCALIZATION";
const SET_NEW_APP_LOCALIZATIONS = "app/apps/SET_NEW_APP_LOCALIZATIONS";
const SET_DEFAULT_APP_KEYS = "app/apps/SET_DEFAULT_APP_KEYS";
const SET_PREV_LOCALE = "app/apps/SET_PREV_LOCALE";
const SET_IS_NEED_REFETCH_LOCALES = "app/apps/SET_IS_NEED_REFETCH_LOCALES";
const SET_EDITING_LOCALIZATION = "app/apps/SET_EDITING_LOCALIZATION";
const SET_ORIGINAL_DEFAULT_LOCALIZATION = "app/apps/SET_ORIGINAL_DEFAULT_LOCALIZATION";
const SET_IS_MISSING_KEYS_MODAL_ACTIVE = "app/apps/SET_IS_MISSING_KEYS_MODAL_ACTIVE";
const SET_MISSING_KEYS_MODAL_DATA = "app/apps/SET_MISSING_KEYS_MODAL_DATA";
const SET_MISSING_KEYS_MODAL_LOCALIZATION = "app/apps/SET_MISSING_KEYS_MODAL_LOCALIZATION";
const SET_IS_MISSING_KEYS_MODAL_LOCALIZATION_UPLOADED =
  "app/apps/SET_IS_MISSING_KEYS_MODAL_LOCALIZATION_UPLOADED";
const SET_IS_FILE_UPLOAD_DECLINED = "app/apps/SET_IS_FILE_UPLOAD_DECLINED";
const SET_FEATURES_MODAL_DATA = "app/apps/SET_FEATURES_MODAL_DATA";
const SET_IS_FEATURES_ACTIVE = "app/apps/SET_IS_FEATURES_ACTIVE";
const SET_IS_FEATURES_ACTIVE_SETTED = "app/apps/SET_IS_FEATURES_ACTIVE_SETTED";
const SET_IS_MARKETS_REASSIGNED = "app/apps/SET_IS_MARKETS_REASSIGNED";
const SET_IS_ROLES_REASSIGNED = "app/apps/SET_IS_ROLES_REASSIGNED";
const SET_PREV_APP_TYPE = "app/apps/SET_PREV_APP_TYPE";
const SET_ORIGINAL_APP_NAME = "app/apps/SET_ORIGINAL_APP_NAME";
const SET_ORIGINAL_APP_LINK = "app/apps/SET_ORIGINAL_APP_LINK";
const SET_IS_ORIGINAL_EMAIL_SETTED = "app/apps/SET_IS_ORIGINAL_EMAIL_SETTED";
const SET_ORIGINAL_MARKET_LOCALIZATIONS = "app/apps/SET_ORIGINAL_MARKET_LOCALIZATIONS";
const SET_ORIGINAL_LOCALIZATIONS = "app/apps/SET_ORIGINAL_LOCALIZATIONS";
const SET_IS_SAVING_PENDING = "app/apps/SET_IS_SAVING_PENDING";

const initialState = {
  apps: null,
  loading: false,
  refresh: false,
  error: null,
  appsMarkets: {},
  groupError: null,
  selectedApp: {
    groupConfigs: []
  },
  selectedAppMarketsToAdd: [],
  selectedAppMarketsToDelete: [],
  manageType: null,
  activePage: appsConfigurationOptions[0].id,
  lastActiveIndex: 0,
  isGeneralInfoSaved: false,
  originalAvailableDashboards: [],
  originalEmailMessage: "",
  isEmailMessageEditing: false,
  localizationKeys: {},
  prevLocale: "",
  isNeedRefetchLocales: false,
  editingLocalization: null,
  originalDefaultLocalization: null,
  isMissingKeysModalActive: false,
  missingKeysModalData: null,
  missingKeysModalLocalization: null,
  isMissingKeysModalLocalizationUploaded: false,
  isFileUploadDeclined: false,
  featuresModalData: [],
  isFeaturesActive: false,
  isFeaturesActiveSetted: false,
  isMarketsReassigned: false,
  isRolesReassigned: false,
  prevAppType: "",
  originalAppName: "",
  originalAppLink: "",
  originalMarketLocalizations: [],
  originalLocalizations: [],
  isOriginalEmailSetted: false,
  isSavingPending: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PUSH_APPS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        apps: action.payload
      };
    }

    case RESET_APPS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        apps: null
      };
    }

    case SET_PREV_LOCALE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        prevLocale: action.payload
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    case SET_APPS_MARKETS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        appsMarkets: action.payload
      };
    }

    case SET_SELECTED_APP: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        selectedApp: { ...clonedState.selectedApp, ...action.payload }
      };
    }

    case SET_ROLES_TO_SELECTED_APP: {
      const clonedState = cloneDeep(state);

      clonedState.selectedApp.groupConfigs = [...action.payload];
      return {
        ...clonedState
      };
    }

    case SET_SELECTED_APP_MARKETS_TO_ADD: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        selectedAppMarketsToAdd: [...clonedState.selectedAppMarketsToAdd, ...action.payload]
      };
    }

    case SET_SELECTED_APP_MARKETS_TO_DELETE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        selectedAppMarketsToDelete: [...clonedState.selectedAppMarketsToDelete, action.payload]
      };
    }

    case RESET_SELECTED_APP_MARKETS_TO_ADD: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        selectedAppMarketsToAdd: []
      };
    }

    case RESET_SELECTED_APP_MARKETS_TO_DELETE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        selectedAppMarketsToDelete: []
      };
    }

    case RESET_SELECTED_APP: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        selectedApp: {}
      };
    }

    case SET_MANAGE_TYPE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        manageType: action.payload
      };
    }

    case SET_ACTIVE_PAGE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        activePage: action.payload
      };
    }

    case SET_LAST_ACTIVE_INDEX: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        lastActiveIndex: action.payload
      };
    }

    case SET_IS_GENERAL_INFO_SAVED: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isGeneralInfoSaved: action.payload
      };
    }

    case SET_APP_GROUP_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        groupError: action.payload
      };
    }

    case SET_AVAILABLE_DASHBOARDS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        selectedApp: {
          ...clonedState.selectedApp,
          availableDashboards: action.payload
        }
      };
    }

    case SET_APP_LOCALIZATIONS: {
      const clonedState = cloneDeep(state);
      const localization = clonedState.selectedApp.localizations ?? [];
      return {
        ...clonedState,
        selectedApp: {
          ...clonedState.selectedApp,
          localizations: [...localization, action.payload]
        }
      };
    }

    case SET_NEW_APP_LOCALIZATIONS: {
      const clonedState = cloneDeep(state);
      return {
        ...clonedState,
        selectedApp: {
          ...clonedState.selectedApp,
          localizations: action.payload
        }
      };
    }

    case SET_DEFAULT_APP_KEYS: {
      const clonedState = cloneDeep(state);
      return {
        ...clonedState,
        selectedApp: {
          ...clonedState.selectedApp,
          localizationKeys: action.payload
        }
      };
    }

    case DELETE_APP_LOCALIZATION: {
      const clonedState = cloneDeep(state);
      const localization = [...clonedState.selectedApp.localizations].filter(
        (localization) => localization.name !== action.payload
      );

      return {
        ...clonedState,
        selectedApp: {
          ...clonedState.selectedApp,
          localizations: localization
        }
      };
    }

    case SET_ORIGINAL_AVAILABLE_DASHBOARDS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        originalAvailableDashboards: action.payload
      };
    }

    case SET_ORIGINAL_EMAIL_MESSAGE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        originalEmailMessage: action.payload
      };
    }

    case SET_IS_EMAIL_MESSAGE_EDITING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isEmailMessageEditing: action.payload
      };
    }

    case SET_IS_NEED_REFETCH_LOCALES: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isNeedRefetchLocales: action.payload
      };
    }

    case SET_EDITING_LOCALIZATION: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        editingLocalization: action.payload
      };
    }

    case SET_ORIGINAL_DEFAULT_LOCALIZATION: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        originalDefaultLocalization: action.payload
      };
    }

    case SET_IS_MISSING_KEYS_MODAL_ACTIVE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isMissingKeysModalActive: action.payload
      };
    }

    case SET_MISSING_KEYS_MODAL_DATA: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        missingKeysModalData: action.payload
      };
    }

    case SET_MISSING_KEYS_MODAL_LOCALIZATION: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        missingKeysModalLocalization: action.payload
      };
    }

    case SET_IS_MISSING_KEYS_MODAL_LOCALIZATION_UPLOADED: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isMissingKeysModalLocalizationUploaded: action.payload
      };
    }

    case SET_IS_FILE_UPLOAD_DECLINED: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isFileUploadDeclined: action.payload
      };
    }

    case SET_FEATURES_MODAL_DATA: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        featuresModalData: action.payload
      };
    }

    case SET_IS_FEATURES_ACTIVE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isFeaturesActive: action.payload
      };
    }

    case SET_IS_FEATURES_ACTIVE_SETTED: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isFeaturesActiveSetted: action.payload
      };
    }

    case SET_IS_MARKETS_REASSIGNED: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isMarketsReassigned: action.payload
      };
    }

    case SET_IS_ROLES_REASSIGNED: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isRolesReassigned: action.payload
      };
    }

    case SET_PREV_APP_TYPE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        prevAppType: action.payload
      };
    }

    case SET_ORIGINAL_APP_NAME: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        originalAppName: action.payload
      };
    }

    case SET_ORIGINAL_APP_LINK: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        originalAppLink: action.payload
      };
    }

    case SET_IS_ORIGINAL_EMAIL_SETTED: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isOriginalEmailSetted: action.payload
      };
    }

    case SET_ORIGINAL_MARKET_LOCALIZATIONS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        originalMarketLocalizations: action.payload
      };
    }

    case SET_ORIGINAL_LOCALIZATIONS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        originalLocalizations: action.payload
      };
    }

    case SET_IS_SAVING_PENDING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isSavingPending: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const pushApps = (apps) => ({ type: PUSH_APPS, payload: apps });

export const resetApps = () => ({ type: RESET_APPS });

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setError = (error) => ({ type: SET_ERROR, payload: error });
export const setGroupError = (error) => ({ type: SET_APP_GROUP_ERROR, payload: error });

export const setAppsMarkets = (markets) => ({ type: SET_APPS_MARKETS, payload: markets });

export const setSelectedApp = (configuration) => ({
  type: SET_SELECTED_APP,
  payload: configuration
});

export const setGroupToSelectedApp = (group) => ({
  type: SET_ROLES_TO_SELECTED_APP,
  payload: group
});

export const setSelectedAppMarketsToAdd = (markets) => ({
  type: SET_SELECTED_APP_MARKETS_TO_ADD,
  payload: markets
});

export const setSelectedAppMarketsToDelete = (market) => ({
  type: SET_SELECTED_APP_MARKETS_TO_DELETE,
  payload: market
});

export const resetSelectedAppMarketsToAdd = () => ({ type: RESET_SELECTED_APP_MARKETS_TO_ADD });

export const resetSelectedAppMarketsToDelete = () => ({
  type: RESET_SELECTED_APP_MARKETS_TO_DELETE
});

export const resetSelectedApp = () => ({ type: RESET_SELECTED_APP });

export const setManageType = (type) => ({ type: SET_MANAGE_TYPE, payload: type });

export const setActivePage = (page) => ({ type: SET_ACTIVE_PAGE, payload: page });

export const setLastActiveIndex = (index) => ({ type: SET_LAST_ACTIVE_INDEX, payload: index });

export const setIsGeneralInfoSaved = (value) => ({
  type: SET_IS_GENERAL_INFO_SAVED,
  payload: value
});

export const setAvailableDashboards = (dashboards) => ({
  type: SET_AVAILABLE_DASHBOARDS,
  payload: dashboards
});

export const setOriginalAvailableDashboards = (dashboards) => ({
  type: SET_ORIGINAL_AVAILABLE_DASHBOARDS,
  payload: dashboards
});

export const setOriginalEmailMessage = (emailMessage) => ({
  type: SET_ORIGINAL_EMAIL_MESSAGE,
  payload: emailMessage
});

export const setIsEmailMessageEditing = (isEditing) => ({
  type: SET_IS_EMAIL_MESSAGE_EDITING,
  payload: isEditing
});

export const addLocalizationToApp = (localizations) => ({
  type: SET_APP_LOCALIZATIONS,
  payload: localizations
});

export const deleteAppLocaliztion = (localization) => ({
  type: DELETE_APP_LOCALIZATION,
  payload: localization
});

export const setLocalizationToApp = (localization) => ({
  type: SET_NEW_APP_LOCALIZATIONS,
  payload: localization
});

export const setLocaleKeys = (localeKeys) => ({
  type: SET_DEFAULT_APP_KEYS,
  payload: localeKeys
});

export const setPrevLocale = (localization) => ({
  type: SET_PREV_LOCALE,
  payload: localization
});

export const setIsNeedRefetchLocales = (value) => ({
  type: SET_IS_NEED_REFETCH_LOCALES,
  payload: value
});

export const setEditingLocale = (value) => ({
  type: SET_EDITING_LOCALIZATION,
  payload: value
});

export const setOriginalDefaultLocale = (value) => ({
  type: SET_ORIGINAL_DEFAULT_LOCALIZATION,
  payload: value
});

export const setIsMissingKeysModalActive = (value) => ({
  type: SET_IS_MISSING_KEYS_MODAL_ACTIVE,
  payload: value
});

export const setMissingKeysModalData = (data) => ({
  type: SET_MISSING_KEYS_MODAL_DATA,
  payload: data
});

export const setMissingKeysModalLocalization = (data) => ({
  type: SET_MISSING_KEYS_MODAL_LOCALIZATION,
  payload: data
});

export const setIsMissingKeysModalLocalizationUploaded = (value) => ({
  type: SET_IS_MISSING_KEYS_MODAL_LOCALIZATION_UPLOADED,
  payload: value
});

export const setIsFileUploadDeclined = (value) => ({
  type: SET_IS_FILE_UPLOAD_DECLINED,
  payload: value
});

export const setFeaturesModalData = (data) => ({
  type: SET_FEATURES_MODAL_DATA,
  payload: data
});

export const setIsFeaturesActive = (value) => ({
  type: SET_IS_FEATURES_ACTIVE,
  payload: value
});

export const setIsFeaturesActiveSetted = (value) => ({
  type: SET_IS_FEATURES_ACTIVE_SETTED,
  payload: value
});

export const setIsMarketsReassigned = (value) => ({
  type: SET_IS_MARKETS_REASSIGNED,
  payload: value
});

export const setIsRolesReassigned = (value) => ({
  type: SET_IS_ROLES_REASSIGNED,
  payload: value
});

export const setPrevAppType = (appType) => ({
  type: SET_PREV_APP_TYPE,
  payload: appType
});

export const setOriginalAppName = (appName) => ({
  type: SET_ORIGINAL_APP_NAME,
  payload: appName
});

export const setOriginalAppLink = (appLink) => ({
  type: SET_ORIGINAL_APP_LINK,
  payload: appLink
});

export const setIsOriginalEmailSetted = (value) => ({
  type: SET_IS_ORIGINAL_EMAIL_SETTED,
  payload: value
});

export const setOriginalMarketLocalizations = (value) => ({
  type: SET_ORIGINAL_MARKET_LOCALIZATIONS,
  payload: value
});

export const setOriginalLocalizations = (value) => ({
  type: SET_ORIGINAL_LOCALIZATIONS,
  payload: value
});

export const setIsSavingPending = (value) => ({
  type: SET_IS_SAVING_PENDING,
  payload: value
});
